import { css, type FlattenSimpleInterpolation } from 'styled-components';

export enum Elevation {
  Depth4,
  Depth8,
  Depth16,
  Depth64,
}

export const getElevation = ({ $elevation }: { $elevation?: Elevation }): FlattenSimpleInterpolation => {
  switch ($elevation) {
    case Elevation.Depth4:
      return css`
        box-shadow:
          0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
          0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
      `;
    case Elevation.Depth8:
      return css`
        box-shadow:
          0px 0.6px 1.8px rgba(0, 0, 0, 0.1),
          0px 3.2px 7.2px rgba(0, 0, 0, 0.13);
      `;
    case Elevation.Depth16:
      return css`
        box-shadow:
          0px 1.2px 3.6px rgba(0, 0, 0, 0.1),
          0px 6.4px 14.4px rgba(0, 0, 0, 0.13);
      `;
    case Elevation.Depth64:
      return css`
        box-shadow:
          0px 4.8px 14.4px rgba(0, 0, 0, 0.18),
          0px 25.6px 57.6px rgba(0, 0, 0, 0.22);
      `;
    default:
      return css``;
  }
};
